import { React, useRef, useEffect } from "react";
import io from "socket.io-client";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import VectorImage from "../Images/Vector2.png";
import { userLogout, stateAction } from "../Store/Actions/AuthAction";
import { CLEAR_CHATSTATE } from "../Store/Types/ChatTypes";
import { RESET_AGENT_STATE } from "../Store/Types/AgentTypes";
import { SET_LOGOUT_CLEAR } from "../Store/Types/AuthTypes";
import { clearSessionCall, unregisterSIP } from "../Store/SIP/call";
import consoleLogger from "../Utils/logger";

export default function Error() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { authenticate, myInfo, CurrentState } = useSelector(
    (state) => state.auth
  );
  const app = localStorage.getItem("app");
  const token = localStorage.getItem("token");
  const socket = useRef();

  const cleanTab = () => {
    if (authenticate && !app) {
      if (
        !localStorage.getItem("tabId") ||
        localStorage.getItem("tabId") === sessionStorage.getItem("tabId")
      )
        navigate("/");
    }
  };
  //-----Log Out from Standalone-----
  const logout = async (e) => {
    if (e !== undefined) e.preventDefault();
    dispatch(userLogout());
    dispatch({ type: CLEAR_CHATSTATE });
    dispatch({ type: SET_LOGOUT_CLEAR });
    dispatch({ type: RESET_AGENT_STATE });
    dispatch(clearSessionCall());
    dispatch(stateAction("LOGGEDOFF", "", CurrentState, "", "loggedoff"));
    socket.current.emit("logout", myInfo.user.AgentID);
  };
  //-----Log Out from Standalone-----

  const removeWindow = () => {
    window.localStorage.removeItem("tabId");
  };

  useEffect(() => {
    // Send logs to API
    consoleLogger.sendLogsToAPI().catch(err => 
      console.error('Failed to send error logs:', err)
    );

    socket.current = io(`${process.env.REACT_APP_SOCKET_URL}`);

    //-----Log Out from SmartDesk-----
    function clearLocalStorage(event) {
      if (event.data.delete && app) localStorage.clear();
    }
    //-----Log Out from SmartDesk-----
    window.addEventListener("message", clearLocalStorage);
    if (localStorage.getItem("tabId") === sessionStorage.getItem("tabId")) {
      window.addEventListener("beforeunload", removeWindow);
      window.addEventListener("unload", removeWindow);
    }

    return () => {
      localStorage.removeItem("tabId");
      window.removeEventListener("message", clearLocalStorage);
      if (localStorage.getItem("tabId") === sessionStorage.getItem("tabId")) {
        window.removeEventListener("beforeunload", removeWindow);
        window.removeEventListener("unload", removeWindow);
      }
    };
  }, []);

  useEffect(() => {
    if (!authenticate) {
      navigate("/");
    }
  }, [authenticate]);

  return (
    <div className="notfound">
      <div className="imageContainer">
        <img src={VectorImage}></img>
      </div>
      <div className="textContainer">
        <div className="HeaderError">Oh no, Something Went Wrong!</div>
        <div className="SubHeaderError">Error :</div>
        <div className="ErrorCode">404</div>
        <div className="BodyError">You’re not supposed to be here</div>
        {(!app && !location.state) ||
        (location.state &&
          !location.state.app &&
          location.state.token !== token) ? (
          <div className="errorButtonContainer">
            <button className="ErrorPageButtonLogOut" onClick={logout}>
              Log Out
            </button>
            <button className="ErrorPageButtonPrev" onClick={cleanTab}>
              Return to Previous Page
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
